import * as React from 'react';
import classnames from 'classnames';

import { Link } from 'libs/router';

import PopoverList from 'components/popover-list/PopoverList';
import SVGIcon from 'components/svg-icon/SVGIcon';

import { __t, applyTranslations } from 'utils/language';

import './instagram-data-enabled-badge.scss';

applyTranslations(require('./instagram-data-enabled-badge.i18n.json'));

interface Props {
  hasActiveFbConnection?: boolean,
  influencerCheckOverride?: boolean
}

const MSG_KEY = 'instagram_data_enabled_badge';

const InstagramDataEnabledBadge = ({
  hasActiveFbConnection,
  influencerCheckOverride
}: Props): null | JSX.Element => {
  const show = (hasActiveFbConnection || influencerCheckOverride) ?? false;

  if (show === false) {
    return null;
  }

  const subheader = !hasActiveFbConnection
    ? __t(`${MSG_KEY}.subheader_disabled`)
    : __t(`${MSG_KEY}.subheader_enabled`);

  const popoverTitle = !hasActiveFbConnection
    ? __t(`${MSG_KEY}.tooltip.not_connected.title`)
    : __t(`${MSG_KEY}.tooltip.connected.title`);

  const popoverText = !hasActiveFbConnection
    ? __t(`${MSG_KEY}.tooltip.not_connected.text`)
    : __t(`${MSG_KEY}.tooltip.connected.text`);

  const containerClasses = classnames('instagram-data-enabled-badge__container', {
    'instagram-data-enabled-badge__container--disabled': !hasActiveFbConnection
  });

  const iconClasses = classnames('instagram-data-enabled-badge__icon', {
    'instagram-data-enabled-badge__icon--disabled': !hasActiveFbConnection
  });

  return (
    <div className="instagram-data-enabled-badge">
      <PopoverList
        list={[
          {
            title: popoverTitle,
            body: (
              <div className="instagram-data-enabled-badge__popover-text">
                <span>{popoverText}</span>
                <span>
                  <Link
                    target="_blank"
                    rel="noopener noreferrer"
                    to="https://help.collabary.com/en/articles/6380279-why-should-i-connect-my-instagram-account-to-collabary"
                    className="instagram-data-enabled-badge__link"
                  >
                    {__t(`${MSG_KEY}.tooltip.link`)}
                  </Link>
                </span>
              </div>
            )
          }
        ]}
        trigger={(
          <div className={containerClasses}>
            <SVGIcon
              name="instagram-no-customisation"
              width={24}
              height={24}
              className={iconClasses}
            />
            <div className="instagram-data-enabled-badge__text-container">
              <span>{__t(`${MSG_KEY}.header`)}</span>
              <span>{subheader}</span>
            </div>
          </div>
        )}
      />
    </div>
  );
};

export default InstagramDataEnabledBadge;
